import { capture } from '../../../../utils/analytics';
import { X } from '@phosphor-icons/react';
import { useEffect, useRef } from 'react';

interface MSMobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MSMobileMenu: React.FC<MSMobileMenuProps> = ({ isOpen, onClose }) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) return;

    closeButtonRef.current?.focus();

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseRef.current?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  return (
    <div className="ms-mobile-menu">
      <div
        id="ms-mobile-menu-drawer"
        className={`ms-mobile-menu_drawer ${isOpen ? 'is-open' : ''}`}
        role="navigation"
        aria-label="Mobile navigation"
        aria-hidden={!isOpen}
      >
        <button
          ref={closeButtonRef}
          className="ms-mobile-menu_drawer_close"
          onClick={() => onCloseRef.current?.()}
          aria-label="Close navigation menu"
          tabIndex={isOpen ? 0 : -1}
        >
          <X />
        </button>
        <ul>
          <li>
            <a href="https://www.oraai.com/medicine" tabIndex={isOpen ? 0 : -1}>
              For Students
            </a>
          </li>
          <li>
            <a
              href="https://www.oraai.com/#educators-contact-form"
              tabIndex={isOpen ? 0 : -1}
              onClick={() => {
                capture('ms_book_demo_click', { isHero: false });
              }}
            >
              Book a Demo
            </a>
          </li>
          <hr />
          <li>
            <a href="https://oraai.com/research" tabIndex={isOpen ? 0 : -1}>
              Research
            </a>
          </li>
          <li>
            <a href="https://oraai.com/company" tabIndex={isOpen ? 0 : -1}>
              Company
            </a>
          </li>
          <li>
            <a href="https://oraai.com/blog" tabIndex={isOpen ? 0 : -1}>
              Blog
            </a>
          </li>
        </ul>
      </div>
      <div
        className="mobile-menu_overlay"
        role="button"
        tabIndex={isOpen ? 0 : -1}
        aria-label="Close navigation menu"
        onClick={() => onCloseRef.current?.()}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onCloseRef.current?.();
          }
        }}
      ></div>
    </div>
  );
};

export default MSMobileMenu;
